const SERVICE_AREAS = [
  "Warragamba",
  "Wallacia",
  "Silverdale",
  "Mulgoa",
  "The Oaks",
  "Penrith",
  "Camden",
  "Blue Mountains",
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-16 md:py-24 bg-white border-b border-border"
    >
      <div className="max-w-4xl mx-auto px-6">
        <div className="chip mb-4">About MRL</div>
        <h2 className="font-heading uppercase text-3xl md:text-5xl font-bold tracking-tight text-secondary leading-tight">
          Family-run plant hire,
          <br />
          <span className="text-orange-500">Warragamba based.</span>
        </h2>
        <p className="mt-5 text-muted-foreground leading-relaxed max-w-2xl">
          MRL Plant Hire is a locally owned and operated business serving the Warragamba
          valley and surrounding suburbs. Whether you're a homeowner tackling a backyard
          project, a landscaper cutting paths, or a builder doing site cuts and footings —
          we've got the right gear for the job.
        </p>
        <p className="mt-3 text-muted-foreground leading-relaxed max-w-2xl">
          We pride ourselves on showing up on time, with clean machines that actually work,
          and a no-nonsense approach to pricing. If we can't help, we'll point you to
          someone who can.
        </p>

        <div className="mt-8">
          <div className="text-xs uppercase tracking-[0.2em] text-orange-600 font-heading mb-3">
            Service Areas
          </div>
          <div className="flex flex-wrap gap-2" data-testid="service-areas">
            {SERVICE_AREAS.map((a) => (
              <span
                key={a}
                className="px-3 py-1.5 text-xs uppercase tracking-wider font-heading border border-border bg-muted/40 text-secondary"
              >
                {a}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
